import { parseToHsl } from 'polished';

import { useTheme } from '../../hooks';
import Image from '../Image';

const lightBgImage = `iVBORw0KGgoAAAANSUhEUgAAAJAAAAASCAYAAAC0PldrAAAIHElEQVR4
Ae3ZBXDbWB7H8efglpmZGW0HlhzJDpSZmZkZ3W3s2DpmZmbmKx0zM/NdoGhotxTf9x9LHY027paW85v5bBRQ
opn32weqasqzk5Jw7BE9nHijHo5/Rw/HfqaHYl/keldZ8GJ7qBeqZ/6PNGlPUT5DeVKNqkyc18PJ6VDPtfEf
nvUJz0dmpbwfmzMW6k5YFy96pBRTkCnL4MUDiy94oS0F+ZVZlD/5qxLLfNFkz0D0fBtfKOkpCcffrFfG6vVQ
4hDUc6ypQLdDFmMdMiWIcjywaOHEB8zynPEFa1pCOWnHLw2Bej5oKtDzqEC+cGyoWZ5YaTDeGer57r4LRPLR
Ci40liy0QR4eVB5CG2QhU3KQneG+TM/qQhvk424L1Bwt73P22d9QoFD8bVB3KxVUWTX+gqW1mvvLtbr7Z7V+
z6frNM/UlFIuKAD83I2v5y69eiL3y9dPZP/s2tdyPn39ZN7UVEq5oCz8x+WvjC/SQrEv8/u/z/O9siSUKNfC
8agWSbrRaIH+p3lH1Pg976jxe38gz8JzzLM/g2QhpmIuIjCwB/0cg6HjGAxEsQQtIZmCtbBnLbY4BngZptkG
aQmiMHAUhbCyEJMxCxGsh6QFltruOwIv7BmEfTAQwWwsvYMCTcMqGKat6AJJCXYjD1ZcWIdZsEdK8K50gZLr
oez4+l4G8j1PURlfAJWaMye7Vvd+otbvTVVr7hvVmvc/ci0YyNdAidTHVPa1EzmfuH4iN0WBbnD9H7lu8PXc
10CJYDCVxanvffI8nAZvloQTNenZMXYt/YyJ5Y3tgar9nkCt5n2y4Tl073+5TprPEIYSknW2ARpkWosQOkFS
iijK0BtuHME2ZGMMDLSDpBMMU29bYaIYBxfW4wBGojcmw8BIWM8Vwjq40QMubMR+231TYGAYJN1QhVUYgEHY
gMgdFCiCBeiLYdiJI2iO9og6St4XBgZnKpAWjm2AsmNZO+E8jdlnqzrdvS49aO4fndWLekDVlbmHMoB/MQew
AorCrDML86P6E816QD35lbyhzER/SZcouwJKq0oskd9PSX9aVnm5F1RJVbKQr13IVKCU251b7Xf/WwpcqxfM
kVnngm9MW+sZ6gJeD24N1BHkwUouDmI28hDGBNjTDwZGIR9hFEOiYyu2YRIkY1GFhzAABvrCnpVYbyvQAeTA
yiBHKa2sNUnmY5/jvnwcvYMCbXDMmG1QBR2SJdhu+5l52NXYMsqA7EsXI/5OKBvEhnMKK7LwtePpgYy9HIpB
+lbDIGmFbihLTcAzs6FAuueDUJTkW0hdO5XrhrJc/1reTPk6BfsgZMY7iZS/KumFsmihxIFMBaoNeHxmiT/6
H5+7Y41esJcl7K/pmdD9N64n4tZALYQzs7EDvTMMmgtBW7GWYyUk26DDj/1wYYHt+z7bUhixMXDMVqDFznG5
zX1HIdmDGbDnTvdAGpzZhGWO/2n6ojnCKIIzDNClwQ1LRmU8ETCS3aEysU5r7FHmQckAyUD9sWJgPpSlNlA4
SL7O0vJNqGtfz/6bFKX+SyofyvLk1/IGNcxAX8v9JpS8QpDfX/Ha+nwoC8vplIwFYq/TUFbN+w9Zxqr93vpq
3fOFWn/BJFlioYQ1UEvgzHxsRQ8Y6NdIgY6jDBI3wugGA53QxVa+IAogeQwR9EB3h27IVGwfqjLc1xWSnZgN
Z5bdQYECcGabrcgubMUCPIZjtztQWPsOZpjvPRq52A7KSatKTpV3QfxcXenL61tASUFk8M7q7gIoiywl6UF1
fwBKCmLONAVQlhsn8+aYX/8AVEll4pQ8h7x7grLIRj9TgWo0z8Ppsnqv1eqeyP98hX2hZClrrEDH0QpWWuIY
JiMbQcx1TNWjYWCQbY8TwQbshJXdWI+obdPdEwbGwJ7ipylQH2vZdN5nK9AMHEVzx1JUeQcF2uVY+rojimJY
GY8q7MdEZIy8MGTwfmHuhf5JkTbJex/fyxJdtcpLDzNob5JNrbn/mQMl2ECvNpeKn1sDV6MVjGEz/U9zWSmF
YuO82tzr/PzK6fy+UFdP5o6hNP9M742ySyFL1VJrDxSIXu4NJUunvAXPVCApCfufP5p7rg1y2pMZkeswX/u+
zIawF0jtwyOmvThiK5UXBhbDgwkIY7mjVKthoBRWymE0MngLbXsrN+bbS5WhQC4sRggVjvtGQ9IWQexGMR7B
fjxxBwV6AptRgBIcxU7kwkoODiOCtrhtZOZhkD52m3/KiFGs+VCAdYT3fsicAer5WIcU4DGghPzcta/nfKjh
FPa13HrUybW5fBlQQk5hWmXi/fL3rNnuTk5hdX6Pl79/wTwNXrJOYbIXOh9w98atgVqAx7EPx7AUHWDPSGy2
la0MOY38zCp0gZWuWNXIbJONAPYhhK0YDSsTocGZbJRmuM9KJ6zAceyHD489zYyxCGMwGYdts24LOLMWi3DH
kQ0sg/QqWU5KwvEf4HPMDHseDcc6QTnJUiH7EGajz8g7GPYiH2EWKoOyk/c9vAeax6zzGcryAz5+5PrJ7DIo
O37QxTufhRT0C+zLvst11FrC5JQG5f7IrJd5Pjzzx56Pzh4CJc76CnryHugVPMe3OcqfYTkLymkMCpk30RnT
lG62jfQLIr5gKkf+wVY29lAWWULTM2HsMah70VSgu888bIULL4hw2pqRPhEmfiMbadmbyWzE/utqSSj2nznB
VB7UvWgq0N2lLSIYhxdOWL5k+Xzq/it2mdcGAah7ZV00eQlgxvFRpNfJeyc+Bn2RK32h7sf/AesqcHB02e65
AAAAAElFTkSuQmCC`;

const darkBgImage = `iVBORw0KGgoAAAANSUhEUgAAAJAAAAASCAQAAAAeN5/gAAAFQ0lEQVR4Ae2WA4B
kvRKFX8+sftu2bdvW2rZt27Zt27Zt2xz0Oeflortvz+zgYb016ORUpW7ypW46/7oSjR+gFWZhKUazpO4Ic10
33omh8hiO6Pf/PSsGS3r9slkkaqB5WH8EcyVvpG7HSgmbmYOP6Ha+jfYgK119gAZrelj/MGonc2QvCTN4S0j
hc8HmdUB8VsJJ3hfPceEB8RbdL1+orxR8SDcna9K38mFFehWlUSqPL8Lj8fEh3pIQIN6Z1NJZVkKnhP2KYBa
MwVIM5S+Jaj5mNNp8NOF3qq+3vID4EjpjAcYxncsD/dFC3eGXsIGfuikr4ZgEYAjvNRHNMdVdyFQschaM4Wh
lkt2FIaCEg8rr5mqKTvBjpslyN4bZvgPM6S7vG2yVjLcLhsUD1AoTZNlivmQiy2Gdsz3yYRo6BuO6SCzgwdU
98MMMJjYSgyQAeyQJzUzI+TUfetjaQQmxkrKHAOlrREnYizMS6jg0p1sL4jfGNRVn9bx9hAK1+D6zYT+WKqV
hKT1uIp+XJL5vgwEzKQIzsYN/8n00kfiHnesMpjGb3jK+udjGP4yvucSfzZjXEI0J/MJgmgV/PEB+9OFH/AW
rsZ938QnAQc6PJH4XBqhgsDdZQbMgKq8N+GFrptgq8fvza2bmwjI+Ylrv45gXkFJiN/z6Rz7dji0S33YA7ed
N9mRuwC501s04p/ruHn0q8S/egigWMr1KWIKlaGxaGRGj2/iFxI/cyY7DDDvXDqZ2qkXie65vCqaY/72xxfX
dgkPxAM12CpoPI4YVjTIUKywFPbFWvrBXrGuw9yLft35QU0IjEzvTXZIx/imhTwKaAct3Xa2CFxA/kzBAd7O
sXevb+KMDqH9oh7CS7zlV4hbjEQsWRmKs+b+MFVkZ243ax/Sd6QJ+60fCUTvXIPfBFcN8B83oDWgbfM6guIB
YIdieh+Hu1nzEuxDF/KE4PiPhDB+K/83GdOZzq6Q0nsgZCWgbPdovYYDSSdiBKBCj+ZMiA6/YkNCjsIRvSvw
0cMDhJGqZNNkQxVclPscXLXw4wtxGLQm/3tLrzg9f9cJmWcTwzaDvFZN7DTqH7j3xAFULtpdakOXDEvRhCRz
jTWGRPSTM996e+QuAQ1YUZoQqQ/9I6JWANkXiO65WPgzQhxJiUM8+UHwhQCf5gNXivTiKJkqFI+jhFnxaSV/
bt9dYzMJqS8M6zAR4r1HfsXfONhaKA+gDiX8FfS+bce1wkHe6r9HpuICw1tlTvQ6ykB2VBTHYjgbh1aLbsFz
CLhbmc3yAH6INIOkfe0QuCcv5hH3e7ZT4TQJaVglL9ah9Bh31AlKkVV0soAimRh3M5zMuIGxlURbBZuzX/W7
Swcqu+ojCKAcVJkqoYbfqSIHloT/OoR6zorfE9F5A8mEQzqKu60trlEcNhvUsyKLYhhNxAek4FjAPy+EQVvM
GS2Nq7INfj8a/S2OAPIaTTB+s9z4SiEO23iBBzYdeAQ0xXkDWpuOYhBM4I2GrHnUA9WUpbMUxDONTgeMMCyx
sqKU0QWU8X7Rbr5hWYEqpWA1bcAZLnD1Ew+BZYnyoga0hn/09MgYnsY1lWAINwxY9kOnRxAAxtct7AiqmaGA
C96G3TfQULMBIk+uesHtWWgwzej9+m4SWAaMxFw1YQWIWa+ZazOfc+m6M2ZrOarrddN1dvwzNPvM+uhCZlUK
/81mnjbYSP0ko8rIGhJ5aLN8FAfS7hDV8W7cxI6KxR6muQEB6FLHMfIFy+9BUruGsvk4iHE1Y+fIDxNS6W5E
XMP9naInerKbHk4r8N92vxYnZpeVdAAAAAElFTkSuQmCC`;

const darkMode = (bgColor: string): boolean => {
  return parseToHsl(bgColor).lightness < 0.5;
};

const PoweredByGoogleImage = () => {
  const theme = useTheme();
  return (
    <Image
      src={`data:image/png;base64, ${
        darkMode(theme.base.palette['primary-background']) ? darkBgImage : lightBgImage
      }`}
      alt='Powered by Google'
    />
  );
};

export default PoweredByGoogleImage;
